import React from 'react';
import RadioButton from '@/v2/components/RadioButton/RadioButton';
import SelectableCard from '@/v2/components/Cards/SelectableCard/SelectableCard';

type RadioCardProps = {
  title: string;
  subtitle: string;
  selected: boolean;
  onSelect: () => void;
  disabled: boolean;
  children: React.ReactNode;
  variant?: 'vertical' | 'horizontal';
  size?: 'default' | 'compact';
  ariaLabel?: string;
  testId?: string;
};

export default function RadioCard({ children, ...props }: RadioCardProps) {
  return (
    <SelectableCard
      addonBefore={<RadioButton selected={props.selected} />}
      {...props}
      ariaRole="radio"
      ariaLabel={props.ariaLabel}
      data-testid={props.testId}
    >
      {children}
    </SelectableCard>
  );
}

RadioCard.Skeleton = SelectableCard.Skeleton;
